import fetch from "../helpers/fetch";

const getInstitutions = () =>
  fetch('/api/institutions', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const postInstitution = institution =>
  fetch('/api/institution/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(institution),
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const putInstitution = ({ uuid, ...updates }) =>
  fetch(`/api/institution/${uuid}/update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(updates)
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const deleteInstitution = uuid =>
  fetch(`/api/institution/${uuid}/delete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => error);

export { getInstitutions, postInstitution, putInstitution, deleteInstitution };
